import { computed, observable, when, makeObservable, actionBound } from "mobx";
import OrderDTO from "@/dto/order/OrderDTO";
import { isBlacklistOrder, isManualLockOrder } from "@/utils/OrderUtils";
import { companySettingStore, orderSettingStore } from "./hooks";

class OrderLockStore {
    constructor() {
        makeObservable(this, {
            undeliverableLockOrderIdMapping: observable,
            abnormalAddressLockOrderIdMapping: observable,
            manualLockOrderIdMapping: observable,
            blacklistLockOrderIdMapping: observable,
            lockOrderIdMapping: computed,
            handleLockOrders: actionBound,
            handleUnlockOrder: actionBound,
        });
        orderSettingStore.init();
    }

    /**
     * 不可达上锁索引
     */
    undeliverableLockOrderIdMapping = new Map<number, string>();

    /**
     * 地址异常上锁索引
     */
    abnormalAddressLockOrderIdMapping = new Map<number, boolean>();

    /**
     * 手动上锁索引
     *
     */
    manualLockOrderIdMapping = new Map<number, boolean>();

    /**
     * 黑名单上锁
     */
    blacklistLockOrderIdMapping = new Map<number, boolean>();

    /**
     * 上锁索引
     */
    get lockOrderIdMapping() {
        const map = new Map();

        this.undeliverableLockOrderIdMapping.forEach((value, key) => {
            if (value) {
                map.set(key, value);
            }
        });

        this.abnormalAddressLockOrderIdMapping.forEach((value, key) => {
            if (value) {
                map.set(key, value);
            }
        });

        this.manualLockOrderIdMapping.forEach((value, key) => {
            if (value) {
                map.set(key, value);
            }
        });

        this.blacklistLockOrderIdMapping.forEach((value, key) => {
            if (value) {
                map.set(key, value);
            }
        });

        return map;
    }

    /**
     * 自动上锁订单
     */
    async handleLockOrders(orders: OrderDTO[]) {
        await when(() => !orderSettingStore.loading);

        const undeliverableLockOrderIdMapping = new Map<number, string>();
        const abnormalAddressLockOrderIdMapping = new Map<number, boolean>();
        const manualLockOrderIdMapping = new Map<number, boolean>();
        const blacklistLockOrderIdMapping = new Map<number, boolean>();

        for (const order of orders || []) {
            const isOrderAddressAbnormalLock = orderSettingStore.isOrderAddressAbnormalLock(order);
            const orderAddressUndeliverableLockReason = orderSettingStore.getOrderAddressUndeliverableLockReason(order);
            const _isBlacklistOrder = isBlacklistOrder(order);
            const manualLock = isManualLockOrder(order);

            if (orderAddressUndeliverableLockReason) {
                undeliverableLockOrderIdMapping.set(order.id, orderAddressUndeliverableLockReason);
            }
            if (isOrderAddressAbnormalLock) {
                abnormalAddressLockOrderIdMapping.set(order.id, isOrderAddressAbnormalLock);
            }
            if (manualLock) {
                manualLockOrderIdMapping.set(order.id, manualLock);
            }

            if (_isBlacklistOrder) {
                const lock = await companySettingStore.ensureLockBlacklistOrder(order);

                blacklistLockOrderIdMapping.set(order.id, lock);
            }
        }

        this.undeliverableLockOrderIdMapping = undeliverableLockOrderIdMapping;
        this.abnormalAddressLockOrderIdMapping = abnormalAddressLockOrderIdMapping;
        this.manualLockOrderIdMapping = manualLockOrderIdMapping;
        this.blacklistLockOrderIdMapping = blacklistLockOrderIdMapping;
    }

    /**
     * 订单解锁
     */
    handleUnlockOrder(orderId: number) {
        this.undeliverableLockOrderIdMapping.delete(orderId);
        this.abnormalAddressLockOrderIdMapping.delete(orderId);
        this.manualLockOrderIdMapping.delete(orderId);
        this.blacklistLockOrderIdMapping.delete(orderId);
    }
}

export default OrderLockStore;
